export enum PostpartumEncounterQuestionnaireURLs {
  Encounter = "http://quiltedhealth.com/q/postpartum-encounter",
  Feeding = "http://quiltedhealth.com/q/postpartum-feeding",
  Lochia = "http://quiltedhealth.com/q/postpartum-lochia",
  Output = "http://quiltedhealth.com/q/postpartum-outputs",
  ActivityNutrition = "http://quiltedhealth.com/q/postpartum-activities-nutrition",
  MedicationsTherapies = "http://quiltedhealth.com/q/postpartum-medication-and-therapies",
  Sleep = "http://quiltedhealth.com/q/postpartum-sleep",
  SocialHealth = "http://quiltedhealth.com/q/postpartum-social-health",
  EmotionalHealth = "http://quiltedhealth.com/q/postpartum-emotional-health",
  SexualActivity = "http://quiltedhealth.com/q/postpartum-sexual-activity",
  Vitals = "http://quiltedhealth.com/q/postpartum-vitals",
}

export enum PostpartumEncounterDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

export enum PostpartumEncounterQuestionsLinkIds {
  EncounterNote = "notes",
  EncounterTemplate = "encounterTemplate",
  EncounterType = "encounterType",
  EncounterLocation = "encounterLocation",
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
  EncounterDiagnosisCode = "encounterClientDiagnosisCode",
  EncounterDiagnosisAddToProblemList = "encounterClientDiagnosisAddToProblemList",
  EncounterDiagnosisNotes = "encounterClientDiagnosisNotes",
}

export enum PostpartumFeedingQuestionsLinkIds {
  PostpartumFeeding = "postpartumFeeding",
  PostpartumFeedingType = "postpartumFeedingType",
  PostpartumFeedingSupplement = "postpartumFeedingSupplement",
  PostpartumFeedingWith = "postpartumFeedingWith",
  PostpartumFeedingSupply = "postpartumFeedingSupply",
  PostpartumFeedingPain = "postpartumFeedingPain",
  PostpartumFeedingRedness = "postpartumFeedingRedness",
  PostpartumFeedingDucts = "postpartumFeedingDucts",
  PostpartumFeedingNotes = "postpartumFeedingNotes",
}

export enum PostpartumFeedingQuestionsDisplayNames {
  PostpartumFeeding = "Breast/Chest Feeding",
  PostpartumFeedingType = "How are you feeding your baby?",
  PostpartumFeedingSupplement = "Supplementing with:",
  PostpartumFeedingWith = "Feeding with:",
  PostpartumFeedingSupply = "How is your supply of breast/chest milk?",
  PostpartumFeedingPain = "Any pain with breast/chest feeding?",
  PostpartumFeedingRedness = "Any redness?",
  PostpartumFeedingDucts = "Any edema, engorgement, or plugged ducts?",
  PostpartumFeedingNotes = "Notes",
  Feeding = "Feeding",
}

export enum PostpartumActivityNutritionQuestionsLinkIds {
  PostpartumActivityNutrition = "postpartumActivityNutrition",
  PostpartumActivityNutritionType = "postpartumActivityNutritionType",
  PostpartumActivityNutritionTypeOther = "postpartumActivityNutritionTypeOther",
  PostpartumActivityNutritionDietaryRestrictions = "postpartumActivityNutritionDietaryRestrictions",
  PostpartumActivityNutritionBeveragesCaffeine = "postpartumActivityNutritionBeveragesCaffeine",
  PostpartumActivityNutritionMeals = "postpartumActivityNutritionMeals",
  PostpartumActivityNutritionWater = "postpartumActivityNutritionWater",
  PostpartumActivityNutritionBeverages = "postpartumActivityNutritionBeverages",
  PostpartumActivityNutritionNotes = "postpartumActivityNutritionNotes",
}

export enum PostpartumActivityNutritionQuestionsDisplayNames {
  PostpartumActivityNutrition = "Activity & Nutrition",
  PostpartumActivityNutritionType = "What types of activities are you doing?",
  PostpartumActivityNutritionTypeOther = "Other activities",
  PostpartumActivityNutritionDietaryRestrictions = "Dietary restrictions",
  PostpartumActivityNutritionBeveragesCaffeine = "Caffeine consumption",
  PostpartumActivityNutritionMeals = "Meals per day",
  PostpartumActivityNutritionWater = "Water intake",
  PostpartumActivityNutritionBeverages = "Beverages consumed",
  PostpartumActivityNutritionNotes = "Notes",
}

export enum PostpartumActivityNutritionDietaryRestrictionsOptions {
  None = "None",
  Vegetarian = "Vegetarian",
  Vegan = "Vegan",
  GlutenFree = "Gluten-free",
  DairyFree = "Dairy-free",
  NutFree = "Nut-free",
  Other = "Other",
}

export enum PostpartumLochiaQuestionsLinkIds {
  PostpartumLochia = "postpartumLochia",
  PostpartumLochiaType = "postpartumLochiaType",
  PostpartumLochiaNotes = "postpartumLochiaNotes",
}

export enum PostpartumLochiaQuestionsDisplayNames {
  PostpartumLochia = "Postpartum Lochia",
  PostpartumLochiaType = "What is the presence of lochia?",
  PostpartumLochiaNotes = "Notes",
}

export enum PostpartumSleepQuestionsLinkIds {
  PostpartumSleep = "postpartumSleep",
  PostpartumSleepHours = "postpartumSleepHours",
  PostpartumSleepWakeUp = "postpartumSleepWakeUp",
  PostpartumSleepFallingAsleep = "postpartumSleepFallingAsleep",
  PostpartumSleepStayingAsleep = "postpartumSleepStayingAsleep",
  PostpartumSleepBreathing = "postpartumSleepBreathing",
  PostpartumSleepNotes = "postpartumSleepNotes",
}

export enum PostpartumSleepQuestionsDisplayNames {
  PostpartumSleep = "Postpartum Sleep",
  PostpartumSleepHours = "How many average hours per 24hr period do you sleep?",
  PostpartumSleepWakeUp = "How do you feel when you wake up?",
  PostpartumSleepFallingAsleep = "Do you have problems falling asleep?",
  PostpartumSleepStayingAsleep = "Do you have problems staying asleep?",
  PostpartumSleepBreathing = "Do you have problems snoring or interrupted breathing?",
  PostpartumSleepNotes = "Notes",
}

export enum PostpartumMedicationsTherapiesQuestionsLinkIds {
  MedicationFormset = "postpartumMedicationAndTherapiesMedicationsFormset",
  MedicationFormsetCode = "postpartumMedicationAndTherapiesMedicationsFormsetCode",
  TherapiesFormset = "postpartumMedicationAndTherapiesTherapiesFormset",
  TherapiesFormsetCode = "postpartumMedicationAndTherapiesTherapiesFormsetCode",
  Notes = "postpartumMedicationAndTherapiesNotes",
}

export enum PostpartumSocialHealthQuestionsLinkIds {
  PostpartumSocialHealth = "postpartumSocialHealth",
  PostpartumSocialHealthSmoke = "postpartumSocialHealthSmoke",
  PostpartumSocialHealthSmokeAmount = "postpartumSocialHealthSmokeAmount",
  PostpartumSocialHealthSmokeFrequency = "postpartumSocialHealthSmokeFrequency",
  PostpartumSocialHealthDrink = "postpartumSocialHealthDrink",
  PostpartumSocialHealthDrinkAmount = "postpartumSocialHealthDrinkAmount",
  PostpartumSocialHealthDrinkFrequency = "postpartumSocialHealthDrinkFrequency",
  PostpartumSocialHealthDrugs = "postpartumSocialHealthDrugs",
  PostpartumSocialHealthDrugsType = "postpartumSocialHealthDrugsType",
  PostpartumSocialHealthWork = "postpartumSocialHealthWork",
  PostpartumSocialHealthWorkCapacity = "postpartumSocialHealthWorkCapacity",
  PostpartumSocialHealthWorkFrequency = "postpartumSocialHealthWorkFrequency",
  PostpartumSocialHealthSupport = "postpartumSocialHealthSupport",
  PostpartumSocialHealthSupportBy = "postpartumSocialHealthSupportBy",
  PostpartumSocialHealthNotes = "postpartumSocialHealthNotes",
}

export enum PostpartumSocialHealthQuestionsDisplayNames {
  PostpartumSocialHealth = "Postpartum Social Health",
  PostpartumSocialHealthSmoke = "Do you smoke or vape?",
  PostpartumSocialHealthAmount = "How much?",
  PostpartumSocialHealthSmokeFrequency = "Do you now smoke cigarettes or vape every day, some days, or not at all?",
  PostpartumSocialHealthDrink = "Do you ever drink alcohol?",
  PostpartumSocialHealthDrinkFrequency = "How often do you have a drink containing alcohol?",
  PostpartumSocialHealthDrugs = "Are you using any drugs?",
  PostpartumSocialHealthDrugsType = "Which drug(s)?",
  PostpartumSocialHealthWork = "Will you be returning to work?",
  PostpartumSocialHealthWorkCapacity = "In what capacity will you return to work?",
  PostpartumSocialHealthWorkFrequency = "When will you return to work?",
  PostpartumSocialHealthSupport = "How is your level of support?",
  PostpartumSocialHealthSupportBy = "Supported by:",
  PostpartumSocialHealthNotes = "Notes",
}

export enum PostpartumEmotionalHealthQuestionsLinkIds {
  PostpartumEmotionalHealth = "postpartumEmotionalHealth",
  PostpartumEmotionalHealthMood = "postpartumEmotionalHealthMood",
  PostpartumEmotionalHealthTasks = "postpartumEmotionalHealthTasks",
  PostpartumEmotionalHealthBonding = "postpartumEmotionalHealthBonding",
  PostpartumEmotionalHealthSuicide = "postpartumEmotionalHealthSuicide",
  PostpartumEmotionalHealthHallucinations = "postpartumEmotionalHealthHallucinations",
  PostpartumEmotionalHealthNotes = "postpartumEmotionalHealthNotes",
}

export enum PostpartumEmotionalHealthQuestionsDisplayNames {
  PostpartumEmotionalHealth = "Postpartum Emotional Health",
  PostpartumEmotionalHealthMood = "General Mood?",
  PostpartumEmotionalHealthTasks = "Are you able to perform routine daily tasks to care for yourself and your baby?",
  PostpartumEmotionalHealthBonding = "Bonding with the baby?",
  PostpartumEmotionalHealthSuicide = "Any thoughts of suicide or homicide?",
  PostpartumEmotionalHealthHallucinations = "Experiencing hallucinations?",
  PostpartumEmotionalHealthNotes = "Notes",
}

export enum PostpartumSexualActivityQuestionsLinkIds {
  PostpartumSexualActivity = "postpartumSexualActivity",
  PostpartumSexualActivityResumed = "postpartumSexualActivityResumed",
  PostpartumSexualActivityDiscomfort = "postpartumSexualActivityDiscomfort",
  PostpartumSexualActivityPain = "postpartumSexualActivityPain",
  PostpartumSexualActivityDryness = "postpartumSexualActivityDryness",
  PostpartumSexualActivityContraception = "postpartumSexualActivityContraception",
  PostpartumSexualActivityContraceptionMethod = "postpartumSexualActivityContraceptionMethod",
  PostpartumSexualActivityIUD = "postpartumSexualActivityIUD",
  PostpartumSexualActivityHormoneFree = "postpartumSexualActivityHormoneFree",
  PostpartumSexualActivityProgesteroneContaining = "postpartumSexualActivityProgesteroneContaining",
  PostpartumSexualActivityFuture = "postpartumSexualActivityFuture",
  PostpartumSexualActivityFutureWhen = "postpartumSexualActivityFutureWhen",
  PostpartumSexualActivityNotes = "postpartumSexualActivityNotes",
}

export enum PostpartumSexualActivityQuestionsDisplayNames {
  PostpartumSexualActivity = "Postpartum Sexual Activity",
  PostpartumSexualActivityResumed = "Have you resumed sexual intercourse?",
  PostpartumSexualActivityDiscomfort = "Are you having any discomfort with sexual activity?",
  PostpartumSexualActivityPain = "If yes, when does the pain occur?",
  PostpartumSexualActivityDryness = "Any vaginal dryness?",
  PostpartumSexualActivityContraception = "Planning contraception?",
  PostpartumSexualActivityContraceptionMethod = "If Yes, which method?",
  PostpartumSexualActivityIUD = "If IUD selected",
  PostpartumSexualActivityHormoneFree = "Hormone-Free?",
  PostpartumSexualActivityProgesteroneContaining = "Progestin Containing?",
  PostpartumSexualActivityFuture = "Are you planning a future pregnancy?",
  PostpartumSexualActivityFutureWhen = "When do you plan to start trying for a future pregnancy?",
  PostpartumSexualActivityNotes = "Notes",
}

export enum PostpartumOutputsQuestionsLinkIds {
  PostpartumOutputs = "postpartumOutputs",
  Urine = "Urine",
  UrineNormal = "UrineNormal",
  UrineNormalDetails = "UrineNormalDetails",
  UrineNotNormalDetails = "UrineNotNormalDetails",
  Bowel = "Bowel",
  BowelNormal = "BowelNormal",
  BowelNormalDetails = "BowelNormalDetails",
  BowelNotNormalDetails = "BowelNotNormalDetails",
  Frequency = "Frequency",
  NumberOfTimes = "NumberOfTimes",
  NumberOfDays = "NumberOfDays",
  Notes = "notes",
}

export enum PostpartumOutputsQuestionsDisplayNames {
  PostpartumOutputs = "Outputs",
  Urine = "How is your urination?",
  Bowel = "How are your bowel movements?",
  Frequency = "What is the frequency?",
  FrequencyEG = "E.g. 2 times per 1 day/s",
  NumberOfTimes = "Number of times",
  NumberOfDays = "Number of days",
  Notes = "Notes",
  Normal = "Normal",
  NotNormal = "Not Normal",
}

export enum PostpartumOutputsUrineNormalOptions {
  NoBurning = "no-burning",
  NoFrequencyIssues = "no-frequency-issues",
  NoPain = "no-pain",
  NoUrgency = "no-urgency",
  NoIncontinence = "no-incontinence",
}

export enum PostpartumOutputsUrineNotNormalOptions {
  Burning = "burning",
  Urgency = "urgency",
  FrequencyIssues = "frequency-issues",
  Pain = "pain",
  Incontinence = "incontinence",
}

export enum PostpartumOutputsBowelNormalOptions {
  NoConstipation = "No constipation",
  NoDiarrhea = "No diarrhea",
  NoHemorrhoids = "No hemorrhoids",
  NoIncontinence = "No incontinence",
}

export enum PostpartumOutputsBowelNotNormalOptions {
  Constipation = "Constipation",
  Diarrhea = "Diarrhea",
  Hemorrhoids = "Hemorrhoids",
  Incontinence = "Incontinence",
}

export enum PostpartumOutputsUrineNormalLabels {
  NoBurning = "No burning",
  NoFrequencyIssues = "No frequency issues",
  NoPain = "No pain",
  NoUrgency = "No urgency",
  NoIncontinence = "No incontinence",
}

export enum PostpartumOutputsUrineNotNormalLabels {
  Burning = "Burning",
  Urgency = "Urgency",
  FrequencyIssues = "Frequency issues",
  Pain = "Pain",
  Incontinence = "Incontinence",
}

export enum PostpartumOutputsBowelNormalLabels {
  NoConstipation = "No constipation",
  NoDiarrhea = "No diarrhea",
  NoHemorrhoids = "No hemorrhoids",
  NoIncontinence = "No incontinence",
}

export enum PostpartumOutputsBowelNotNormalLabels {
  Constipation = "Constipation",
  Diarrhea = "Diarrhea",
  Hemorrhoids = "Hemorrhoids",
  Incontinence = "Incontinence",
}

export enum PostpartumVitalsQuestionsLinkIds {
  PostpartumVitals = "postpartumVitals",
  PostpartumVitalsDate = "postpartumVitalsDate",
  PostpartumVitalsTime = "postpartumVitalsTime",
  PostpartumVitalsHeartRate = "postpartumVitalsHeartRate",
  PostpartumVitalsRespiratoryRate = "postpartumVitalsRespiratoryRate",
  PostpartumVitalsSystolicBP = "postpartumVitalsSystolicBP",
  PostpartumVitalsDiastolicBP = "postpartumVitalsDiastolicBP",
  PostpartumVitalsTemperatureValue = "postpartumVitalsTemperatureValue",
  PostpartumVitalsTemperatureUnit = "postpartumVitalsTemperatureUnit",
  PostpartumVitalsTemperatureMethod = "postpartumVitalsTemperatureMethod",
  PostpartumVitalsNotes = "postpartumVitalsNotes",
}

export enum PostpartumVitalsQuestionsDisplayNames {
  PostpartumVitals = "Vitals",
  PostpartumVitalsDate = "Date",
  PostpartumVitalsTime = "Time",
  PostpartumVitalsHeartRate = "Heart Rate",
  PostpartumVitalsRespiratoryRate = "Respiratory Rate",
  PostpartumVitalsSystolicBP = "Systolic Blood Pressure",
  PostpartumVitalsDiastolicBP = "Diastolic Blood Pressure",
  PostpartumVitalsTemperature = "Temperature",
  PostpartumVitalsMethod = "Method",
  PostpartumVitalsNotes = "Notes",
  PostpartumBpm = "bpm",
  PostpartumTemperatureUnit = "F",
}

export enum PostpartumEncounterBotNames {
  Encounter = "Postpartum Encounter - Encounter",
}
